<script>
  import Footer from "../Components/Footer.svelte";
  import Title from "../Components/Title.svelte";
  import { useFocus } from "svelte-navigator";

  const focus = useFocus();
</script>

<svelte:head>
  <meta name="description"
  content="Discover Country Cruel. Loud, hard country music inspired by the likes of John Prine, Dexter Romweber, and Sturgill Simpson">
  <title>About - Country Cruel</title>
</svelte:head>
<h2 use:focus>About</h2>
<main>
  <p>
    Born and raised in the woods of White Cross, North Carolina, Zach White, Ernie Renn, and Ben Noblit have been picking together for years. Separately, they’ve all achieved musical success, most notably Renn with critically acclaimed old-time jug band the Piedmont Regulators and Noblit with Celtic punk-grass outfit <a
    href="http://tanandsober.com/"
    target="_blank">Tan and Sober Gentlemen</a
  >. Together, along with Cackalacky convert Brianne Manning, they form Country Cruel. Drawing inspiration from the likes of John Prine, Doc Watson, Dexter Romweber, Sturgill Simpson, and the Two Dollar Pistols, Country Cruel plays loud, hard country music that tells it like it is.
  </p>
  <Title />

</main>
<Footer />

<style>
  main p {
    line-height: 2rem;
    margin: 0 auto;
    max-width: 38rem;
    padding: .5rem;
  }
  a {
    color: #1d1a12;
  }
</style>
